/* eslint-disable */
import * as Types from '../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import { UserAvatarFragmentDoc } from '../users/UserAvatar.generated.js';
import { AttachmentSnapshotFragmentDoc, ProductAttachmentSnapshotFragmentDoc, AttachmentsFragmentDoc, WithItemAttachmentsFragmentDoc } from '../attachments/Attachments.generated.js';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type MyOrganisationUserAvatarAndTitleData_UserFragment = { __typename: 'User', id: string, title: Types.Salutation, firstname: string, familyname: string, organisationTitle: string, membershipStatus: Types.OrganisationMembershipStatus, organisationId: string, avatar?: { __typename: 'AttachmentSnapshot', id: string, url: string } | null };

export type MyOrganisationUserProfileMenu_UserFragment = { __typename: 'User', id: string, organisationId: string };

export type ModifyUserAvatarMutationVariables = Types.Exact<{
  user: Types.UserModifyInput;
}>;


export type ModifyUserAvatarMutation = { updateViewerUser: { __typename: 'UpdateViewerUserResult', user: { __typename: 'Viewer', id: string, avatar?: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } | null } } };

export const MyOrganisationUserProfileMenu_UserFragmentDoc = gql`
    fragment MyOrganisationUserProfileMenu_User on User {
  id
  organisationId
}
    `;
export const MyOrganisationUserAvatarAndTitleData_UserFragmentDoc = gql`
    fragment MyOrganisationUserAvatarAndTitleData_User on User {
  id
  title
  firstname
  familyname
  organisationTitle
  membershipStatus
  ...UserAvatar
  ...MyOrganisationUserProfileMenu_User
}
    ${UserAvatarFragmentDoc}
${MyOrganisationUserProfileMenu_UserFragmentDoc}`;
export const ModifyUserAvatarDocument = gql`
    mutation ModifyUserAvatar($user: UserModifyInput!) {
  updateViewerUser(user: $user) {
    user {
      id
      avatar {
        ...AttachmentSnapshot
      }
    }
  }
}
    ${AttachmentSnapshotFragmentDoc}`;
export type ModifyUserAvatarMutationFn = Apollo.MutationFunction<ModifyUserAvatarMutation, ModifyUserAvatarMutationVariables>;

/**
 * __useModifyUserAvatarMutation__
 *
 * To run a mutation, you first call `useModifyUserAvatarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useModifyUserAvatarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [modifyUserAvatarMutation, { data, loading, error }] = useModifyUserAvatarMutation({
 *   variables: {
 *      user: // value for 'user'
 *   },
 * });
 */
export function useModifyUserAvatarMutation(baseOptions?: Apollo.MutationHookOptions<ModifyUserAvatarMutation, ModifyUserAvatarMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ModifyUserAvatarMutation, ModifyUserAvatarMutationVariables>(ModifyUserAvatarDocument, options);
      }
export type ModifyUserAvatarMutationHookResult = ReturnType<typeof useModifyUserAvatarMutation>;
export type ModifyUserAvatarMutationResult = Apollo.MutationResult<ModifyUserAvatarMutation>;
export type ModifyUserAvatarMutationOptions = Apollo.BaseMutationOptions<ModifyUserAvatarMutation, ModifyUserAvatarMutationVariables>;